import { Paper, TableCell, TableContainer, Typography } from '@mui/material'
import MyHistory from '../models/MyHistory'
import HomeSegment from './HomeSegment'
import TableView from '../framework/ui/view/table'
import React, { useState } from 'react'
import { HistoryOptions, historyOptionsState, OrderType, useGroupDescriptors, useMyHistory } from '../atoms/portale'
import { NullableString } from '../models/ServiceDescriptor';
import { useReuseHistory } from './StartApplication'
import { useRecoilState } from 'recoil'
import { HistoryOptionsDialog } from './HistoryOptionsDialog'
import { useConfirmDialog } from './ConfirmDialog'
import { useTranslation } from 'react-i18next'
// import logConstants from '../utils/logConstants'

const parseContesto = (contesto: NullableString) => {
    if (contesto) {
        const temp = contesto.split(';')
        const hasThree = temp.length > 2
        if (contesto.startsWith('O')) {
            return {
                type: temp[0],
                context: `${temp[1]} - ${temp[3]}`,
                prov: hasThree ? temp[2] : ''
            }
        } else {
            return {
                type: temp[0],
                context: temp[1],
                prov: hasThree ? temp[2] : ''
            }
        }
    }
    return {
        type: '',
        context: '',
        prov: ''
    }
}

const formatDate = (d: string) => {
    const temp = d.split('.')[0].split('T')
    const t2 = temp[0].split('-')
    return `${t2[2]}/${t2[1]}/${t2[0]} ${temp[1]}`
}


export type OptionsOpenType = {
    open: boolean,
    anchorEl?: HTMLDivElement,
}
export const HistorySegment = () => {
    const { openConfirm, closeConfirm } = useConfirmDialog()
    const [options, setOptions] = useRecoilState(historyOptionsState)
    const [optionsOpen, setOptionsOpen] = useState<OptionsOpenType>({ open: false })
    const { historyLoadable, refresh: refreshHistory, purge: purgeHistory, truncate: truncateHistory } = useMyHistory()
    const { dictionary: groupDic } = useGroupDescriptors()
    const {t} = useTranslation();
    const startHistoryApplication = useReuseHistory()
    const handleStartAppl = (item: MyHistory) => (ev: React.MouseEvent<HTMLTableCellElement>) => {
        startHistoryApplication(item)
    }
    const getTitle = (hist: MyHistory) => {
        const group = groupDic[hist.serviceDescriptor.groupDescriptorId]
        const sd = hist.serviceDescriptor
        return `Gruppo: ${group.label} (${group.id}), ApplId: ${sd.id}, HistId: ${hist.id} - Contesto: ${hist.contesto}`
    }
    const handleToggleOptions = (anchorEl: HTMLDivElement) => {
        setOptionsOpen(current => {
            if (current.open) {
                return { open: false }
            } else {
                return {
                    open: true,
                    anchorEl
                }
            }
        })
    }
    const handleSaveOptions = (o: HistoryOptions) => {
        setOptions(o)
        setOptionsOpen(current => ({ ...current, open: false }))
    }
    const handleAnnullaOptions = () => {
        setOptionsOpen(current => ({ ...current, open: false }))
    }
    const handleDelete = (keep?: number, order?: OrderType) => {
        // console.log(`%chandleDelete: keep: ${keep} - order: ${order}`, logConstants.green12ptBold)
        if(keep) {
            openConfirm({
                title: t('Riduzione Storia'),
                prompt: `${t('Riduco la storia a')} ${keep} ${t('righe')}`,
                cancelText: t('Annulla'),
                confirmText: t('Cancella'),
                cancel: () => closeConfirm(),
                confirm: () => {
                    purgeHistory(keep, order ?? 'date').then(() => refreshHistory())
                    // console.log('Riduzione Effettuata')
                    closeConfirm()
                },
                onClose: () => closeConfirm(),
                children: (<Typography sx={{ mb: 2 }} variant='body2'>{t('Riduzione storia esecuzione delle applicazioni a')} {keep} {t('righe')}</Typography>)
            })
        } else {
            openConfirm({
                title: t('Cancellazione Storia'),
                prompt: t('Elimino tutta la storia?'),
                cancelText: t('Annulla'),
                confirmText: t('Cancella'),
                cancel: () => closeConfirm(),
                confirm: () => {
                    truncateHistory().then(() => refreshHistory())
                    // console.log('Cancellazione Effettuata')
                    closeConfirm()
                },
                onClose: () => closeConfirm(),
                children: (<Typography sx={{ mb: 2 }} variant='body2'>{t('Cancellazione storia esecuzione delle applicazioni')}</Typography>)
            })
        }
    }
    return (
        <>
            <HomeSegment title='History' nrec={historyLoadable.contents?.length} onOptionsToggle={handleToggleOptions}>
                {(historyLoadable.state === 'hasValue' && historyLoadable.contents)
                    ? <Paper sx={{ mt: 0.5 }}>
                        <TableContainer sx={{ px: 0.5 }}>
                            <TableView
                                items={historyLoadable.contents}
                                itemKey={(item: MyHistory) => item.id}
                                thDefs={<>
                                    <TableCell><Typography color='primary'>Applicazione</Typography></TableCell>
                                    <TableCell><Typography color='primary'>Descrizione</Typography></TableCell>
                                    <TableCell><Typography color='primary'>Contesto</Typography></TableCell>
                                    <TableCell><Typography color='primary'>Ultimo Run</Typography></TableCell>
                                    <TableCell><Typography color='primary'>N.Run</Typography></TableCell>
                                </>}
                                trDefs={(row: MyHistory) => (<>
                                    <TableCell onClick={handleStartAppl(row)} sx={{ cursor: 'pointer', color: (theme) => theme.palette.secondary.dark, fontWeight: 'bold' }} title={getTitle(row)}>{row.serviceDescriptor.urlDescription}</TableCell>
                                    <TableCell>{row.serviceDescriptor.note}</TableCell>
                                    <TableCell>{parseContesto(row.contesto).context}</TableCell>
                                    <TableCell>{formatDate(row.dataUltimoLancio)}</TableCell>
                                    <TableCell sx={{ textAlign: 'center' }}>{row.counter}</TableCell>
                                </>)}
                            />
                        </TableContainer>
                    </Paper>
                    : <Typography>Loading...</Typography>
                }
            </HomeSegment>
            <HistoryOptionsDialog
                open={optionsOpen.open}
                anchorEl={optionsOpen.anchorEl as HTMLElement}
                options={options}
                onSave={handleSaveOptions}
                onAnnulla={handleAnnullaOptions}
                onDelete={handleDelete}
            />
        </>
    )
}

